// extracted by mini-css-extract-plugin
export default {"cartContainer":"CartPage_cartContainer__95M4R","backBtnWrapper":"CartPage_backBtnWrapper__Deb8J","backBtn":"CartPage_backBtn__tNv60","cartPageTitle":"CartPage_cartPageTitle__gSiws"};